import React from 'react';
import P from 'prop-types';
import cx from 'classnames';
import styled from 'styled-components';

import './Button.scss';

const StyledButton = styled.button`
  background-color: ${({ theme, color }) => {
    return theme[color] || theme.primary;
  }};
  color: ${({ theme, color }) => {
    return theme[`${color}Foreground`] || theme.primaryForeground;
  }};
`;

const Button = ({
  color, type, disabled, children, onClick, className,
  underlineText, leftAlignText, rightAlignText,
}) => {
  return (
    <StyledButton
      color={color}
      type={type}
      className={cx(
        'Button',
        {
          'is-transparent': color === 'transparent',
          'is-leftAligned': leftAlignText,
          'is-rightAligned': rightAlignText,
          'is-underlined': underlineText,
        },
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <div>
        {children}
      </div>
    </StyledButton>
  );
};

Button.propTypes = {
  color: P.string,
  type: P.string,
  disabled: P.bool,
  children: P.node.isRequired,
  onClick: P.func,
  className: P.string,
  underlineText: P.bool,
  leftAlignText: P.bool,
  rightAlignText: P.bool,
};

Button.defaultProps = {
  type: 'button',
  disabled: false,
};

export default Button;
